import React, { useRef, useState, useCallback, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Snackbar,
  Alert,
  Tooltip,
  // Skeleton,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
// import Draggable from "react-draggable";
// import CancelPresentationOutlinedIcon from "@mui/icons-material/CancelPresentationOutlined";
import { styled } from "@mui/material/styles";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ModalLoadingOverlay, {
  modalLoadingContainerSx,
} from "./ModalLoadingOverlay";
// import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
// import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import axios from "axios";

export default function AddBulkCandidates({
  pollStatus,
  setUploadProgress,
  setUploadingFiles,
  setUploadPanelOpen,
  setProcessedFiles,
  isProcessing,
  setIsProcessing,
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [allFiles, setAllFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef();
  const addMoreFileInputRef = useRef();
  const [uploading, setUploading] = useState(false);
  // const [uploadPanelOpen, setUploadPanelOpen] = useState(false);
  // const [uploadingFiles, setUploadingFiles] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [processedFiles, setProcessedFiles] = useState([]);
  // const [uploadProgress, setUploadProgress] = useState(0);
  // const navigate = useNavigate();
  // const [showSuccess, setShowSuccess] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || e.dataTransfer.files || []);
    const MAX_SIZE_MB = 3;
    const MAX_FILE_COUNT = 20;
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
    ];
    if (files.length > MAX_FILE_COUNT) {
      setSnackbar({
        open: true,
        message: `More than ${MAX_FILE_COUNT} files are not supported.`,
        severity: "error",
      });
      return;
    }

    const currentFileCount = allFiles.length;
    if (currentFileCount + files.length > MAX_FILE_COUNT) {
      setSnackbar({
        open: true,
        // message: `Adding these would exceed the maximum of ${MAX_FILE_COUNT} files.`,
        message: `More than ${MAX_FILE_COUNT} files are not supported.`,
        severity: "error",
      });
      return;
    }
    const validFiles = [];
    const unsupportedFiles = [];
    const oversizedFiles = [];
    const duplicateNames = new Set();
    let newFileCount = currentFileCount;

    const existingNames = new Set(
      allFiles.map((f) => f.file.name.trim().toLowerCase())
    );
    const batchNames = new Set();

    for (const file of files) {
      const nameKey = file.name.trim().toLowerCase();

      if (existingNames.has(nameKey) || batchNames.has(nameKey)) {
        duplicateNames.add(nameKey);
        continue;
      }

      if (!allowedTypes.includes(file.type)) {
        unsupportedFiles.push(file.name);
        continue;
      }

      const sizeInMB = file.size / (1024 * 1024);
      if (sizeInMB > MAX_SIZE_MB) {
        oversizedFiles.push(file.name);
        continue;
      }

      if (newFileCount >= MAX_FILE_COUNT) {
        setSnackbar({
          open: true,
          message: `A maximum of ${MAX_FILE_COUNT} files can be uploaded.`,
          severity: "warning",
        });
        break;
      }

      validFiles.push({ file, selected: true });
      batchNames.add(nameKey);
      newFileCount++;
    }

    if (duplicateNames.size > 0) {
      setSnackbar({
        open: true,
        message:
          duplicateNames.size === 1
            ? "This file has already been uploaded."
            : `${duplicateNames.size} files have already been uploaded.`,
        severity: "warning",
      });
    } else if (unsupportedFiles.length > 0) {
      setSnackbar({
        open: true,
        message:
          unsupportedFiles.length === 1
            ? "Unsupported file (only PDF, DOC, DOCX, and TXT are allowed)."
            : `${unsupportedFiles.length} unsupported files (only PDF, DOC, DOCX, and TXT are allowed).`,
        severity: "error",
      });
    } else if (oversizedFiles.length > 0) {
      setSnackbar({
        open: true,
        message:
          oversizedFiles.length === 1
            ? "Selected file exceeds the 3MB size limit."
            : `${oversizedFiles.length} files exceed the 3MB size limit and were not added.`,
        severity: "error",
      });
    }

    if (validFiles.length > 0) {
      setAllFiles((prev) => [...prev, ...validFiles]);
      setDialogOpen(false);
      setPreviewDialogOpen(true);
    }
  };
  // useEffect(() => {
  //   if (uploadProgress === uploadingFiles.length && uploadingFiles.length > 0) {
  //     const timer = setTimeout(() => {
  //       setShowSuccess(true);
  //     }, 2000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [uploadProgress, uploadingFiles.length]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // const handleOpenDetails = () => {
  //   navigate("/added-candidates", { state: { processedFiles } });
  // };

  const handleToggleAll = () => {
    const allSelected = allFiles.every((f) => f.selected);
    const updated = allFiles.map((f) => ({
      ...f,
      selected: !allSelected,
    }));
    setAllFiles(updated);
  };
  const getAllFilesFromItems = async (items) => {
    const files = [];

    const traverseEntry = async (entry, path = "") => {
      if (entry.isFile) {
        await new Promise((resolve, reject) => {
          entry.file(
            (file) => {
              file.fullPath = path + file.name;
              files.push(file);
              resolve();
            },
            (err) => reject(err)
          );
        });
      } else if (entry.isDirectory) {
        const reader = entry.createReader();

        const readAll = async () => {
          const entries = await new Promise((resolve, reject) => {
            reader.readEntries(resolve, reject);
          });
          if (!entries.length) return;

          for (const e of entries) {
            await traverseEntry(e, path + entry.name + "/");
          }
          await readAll();
        };

        await readAll();
      }
    };

    const roots = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry?.();
      if (entry) roots.push(entry);
    }

    for (const root of roots) {
      await traverseEntry(root, "");
    }

    return files;
  };

  const uploadAllCandidates = async (files) => {
    try {
      setIsProcessing(true);
      const formData = new FormData();

      files.forEach((file) => {
        formData.append("resumes", file.file);
      });

      const { data } = await axios.post("/create-bulk-candidates", formData, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });

      return data;
    } catch (error) {
      setIsProcessing(false);
      console.error("Bulk upload failed:", error);
      throw error;
    }
  };

  // const pollStatus = (jobId) => {
  //   const intervalId = setInterval(async () => {
  //     try {
  //       const { data } = await axios.get(`/status/${jobId}`, {
  //         headers: {
  //           authorization:
  //             Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
  //         },
  //       });

  //       const { total, processed } = data.message;
  //       setUploadProgress(processed);
  //       setProcessedFiles(data.message.processedFiles);
  //       console.log(`Progress: ${processed}/${total}`);

  //       if (parseInt(total) === parseInt(processed)) {
  //         clearInterval(intervalId);
  //         console.log("Processing complete!");
  //       }
  //     } catch (err) {
  //       console.error("Error polling status:", err);
  //       clearInterval(intervalId);
  //     }
  //   }, 1000);
  // };

  const handleToggleSingle = (index) => {
    const updated = [...allFiles];
    updated[index].selected = !updated[index].selected;
    setAllFiles(updated);
  };

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const items = e.dataTransfer.items;
    if (items && items.length > 0) {
      const filesFromFolders = await getAllFilesFromItems(items);

      const MAX_FILE_COUNT = 20;
      if (filesFromFolders.length > MAX_FILE_COUNT) {
        setSnackbar({
          open: true,
          message: `More than ${MAX_FILE_COUNT} files are not supported.`,
          severity: "error",
        });
        return;
      }

      handleFileChange({ target: { files: filesFromFolders } });
    }
  }, []);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const selectedCount = allFiles.filter((f) => f.selected).length;

  return (
    <Box>
      <Tooltip
        title={
          isProcessing
            ? "Bulk upload in progress. Please wait until it's finished."
            : ""
        }
        arrow
        disableHoverListener={!isProcessing}
      >
        <span>
          <Button
            variant="contained"
            size="small"
            startIcon={<GroupAddIcon />}
            onClick={() => setDialogOpen(true)}
            disabled={isProcessing}
          >
            ADD BULK CANDIDATES
          </Button>
        </span>
      </Tooltip>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        sx={{ "& .MuiPaper-root": { borderRadius: 3, width: "580px" } }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontSize={"22px"}>
              Add Bulk Candidates
            </Typography>
            <IconButton onClick={() => setDialogOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <Box sx={{ p: 4, display: "flex", flexDirection: "column", gap: 3.5 }}>
          <Box textAlign="center">
            <Typography fontSize="18px" fontWeight="700" color="#0F0F0F">
              Upload file
            </Typography>
            <Typography fontSize="12px" color="#616161">
              Please select relevant documents to complete process
            </Typography>
          </Box>

          <Box
            border={`2px dashed ${isDragging ? "#3F95EA" : "#c4c4c4"}`}
            borderRadius={2}
            p={"40px 100px 50px"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor={isDragging ? "#F0F7FF" : "transparent"}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            sx={{
              transition: "background-color 0.3s, border-color 0.3s",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <FileUploadOutlinedIcon fontSize="large" color="primary" />
              <Typography color={isDragging ? "primary" : "inherit"}>
                Select a file/folder or drag and drop here
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                fontSize="12px"
              >
                txt, docx & pdf file size no more than{" "}
                <Typography component="span" color="#E25C72" fontSize="12px">
                  3MB
                </Typography>
              </Typography>
            </Box>
            <Button
              variant="contained"
              sx={{ width: "100%", textTransform: "capitalize" }}
              onClick={(e) => {
                e.stopPropagation();
                fileInputRef.current.click();
              }}
            >
              Select File
              <VisuallyHiddenInput
                ref={fileInputRef}
                type="file"
                multiple
                accept=".pdf,.docx,.txt,.doc"
                onChange={handleFileChange}
                webkitdirectory
                mozdirectory
                directory
              />
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={previewDialogOpen}
        onClose={() => setPreviewDialogOpen(false)}
        sx={{
          "& .MuiPaper-root": modalLoadingContainerSx(uploading, {
            borderRadius: 3,
            width: "600px",
            maxHeight: "100vh",
          }),
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Add Bulk Candidates</Typography>
            <IconButton
              onClick={() => {
                setPreviewDialogOpen(false);
                setDialogOpen(true);
                setAllFiles([]);
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={1.5}
          bgcolor={"#F7F8FA"}
        >
          <Box display="flex" alignItems="center" flex={1}>
            {allFiles.length > 0 && (
              <>
                <Checkbox
                  edge="start"
                  checked={allFiles.every((f) => f.selected)}
                  indeterminate={
                    allFiles.some((f) => f.selected) &&
                    !allFiles.every((f) => f.selected)
                  }
                  onChange={handleToggleAll}
                  sx={{
                    borderRadius: "50%",
                    "& .MuiSvgIcon-root": { borderRadius: "50%" },
                  }}
                />
                <Typography fontWeight={600}>
                  {allFiles.every((f) => f.selected)
                    ? `All (${selectedCount} Candidates Selected)`
                    : `${selectedCount} Candidates Selected`}
                </Typography>
              </>
            )}
          </Box>

          <Button
            variant="contained"
            size="small"
            startIcon={<AddOutlinedIcon />}
            onClick={(e) => {
              e.stopPropagation();
              addMoreFileInputRef.current.click();
            }}
            sx={{ textTransform: "capitalize" }}
          >
            Add More Candidates
            <VisuallyHiddenInput
              ref={addMoreFileInputRef}
              type="file"
              multiple
              accept=".pdf,.docx,.txt,.doc"
              onChange={handleFileChange}
              webkitdirectory
              mozdirectory
              directory
            />
          </Button>
        </Box>

        <DialogContent dividers sx={{ maxHeight: "100vh", overflowY: "auto" }}>
          {allFiles.length > 0 ? (
            <List dense>
              {allFiles.map((f, index) => (
                <ListItem
                  key={index}
                  sx={{ py: 0, px: 0 }}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => {
                        setAllFiles((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                      }}
                    >
                      <DeleteOutlineIcon color="error" />
                    </IconButton>
                  }
                >
                  <Checkbox
                    edge="start"
                    checked={f.selected}
                    onChange={() => handleToggleSingle(index)}
                    sx={{
                      borderRadius: "50%",
                      "& .MuiSvgIcon-root": {
                        borderRadius: "50%",
                      },
                    }}
                  />
                  <TaskOutlinedIcon
                    sx={{
                      mr: 2,
                      color: "#979797",
                      border: "1px solid #3F95EA33",
                      borderRadius: "8px",
                      padding: "6px",
                      fontSize: "38px",
                    }}
                  />

                  <ListItemText
                    primary={
                      f.file.name.length > 40
                        ? `${f.file.name.slice(0, 40)}...`
                        : f.file.name
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize={12}
                      >
                        {f.file.size < 1024 * 1024
                          ? `${(f.file.size / 1024).toFixed(2)} KB`
                          : `${(f.file.size / (1024 * 1024)).toFixed(2)} MB`}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box
              sx={{
                minHeight: 100,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography color="text.secondary">No files selected</Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
          <Button
            className="cancel-btn"
            variant="outlined"
            onClick={() => {
              setPreviewDialogOpen(false);
              // setDialogOpen(true);
              setAllFiles([]);
            }}
            sx={{ width: "100%", textTransform: "capitalize" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={selectedCount === 0}
            onClick={async () => {
              const selectedFiles = allFiles.filter((f) => f.selected);
              setUploading(true);
              setUploadingFiles(selectedFiles);
              setUploadPanelOpen(true);
              setProcessedFiles([]);
              setUploadProgress(0);

              try {
                const res = await uploadAllCandidates(selectedFiles);
                if (res?.message?.jobId) {
                  localStorage.setItem(
                    "bulkUploadFiles",
                    JSON.stringify(selectedFiles.map((f) => f.file.name)),
                  );
                  pollStatus(res.message.jobId);
                }
                setPreviewDialogOpen(false);
                setDialogOpen(false);
                setAllFiles([]);
              } catch (err) {
                console.error(err);
                setSnackbar({
                  open: true,
                  message: err.message || "Bulk upload failed",
                  severity: "error",
                });
                setUploadPanelOpen(false);
              } finally {
                setUploading(false);
              }
            }}
            type="submit"
            sx={{ width: "100%", textTransform: "capitalize" }}
          >
            Add
          </Button>
        </DialogActions>
        <ModalLoadingOverlay open={uploading} />
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* {uploadPanelOpen && (
        <Draggable handle=".upload-drag-handle">
          <Box
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              width: 480,
              zIndex: 1300,
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Box
              className="upload-drag-handle"
              sx={{
                cursor: "move",
                p: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontWeight="500">Adding Bulk Candidates</Typography>
              {uploadProgress >= uploadingFiles.length ? (
                <IconButton onClick={() => setUploadPanelOpen(false)}>
                  <CloseIcon />
                </IconButton>
              ) : (
                <OpenInNewOutlinedIcon
                  sx={{
                    border: "1px solid #D9EAFB",
                    borderRadius: "8px",
                    padding: "6px",
                    fontSize: "28px",
                    color: "#1A1A1A",
                    cursor: "pointer",
                  }}
                  onClick={handleOpenDetails}
                />
              )}
            </Box>
            <Divider />

            {uploadProgress < uploadingFiles.length ? (
              <>
                <Box p={"20px 20px 0px 20px"}>
                  {processedFiles.slice(0, 2).map((file, index) => (
                    <Box key={index} mb={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={2}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={2}
                          flex={1}
                        >
                          {file.status === "completed" ? (
                            <TaskOutlinedIcon
                              sx={{
                                color: "#4CAF50",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "38px",
                              }}
                            />
                          ) : (
                            <CancelPresentationOutlinedIcon
                              sx={{
                                color: "#E25C72",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "38px",
                              }}
                            />
                          )}

                          <Box>
                            <Typography
                              variant="body1"
                              color="text.primary"
                              fontWeight="bold"
                              fontSize={18}
                              noWrap
                              sx={{ maxWidth: 220 }}
                            >
                              {file.fileName}
                            </Typography>
                            <Typography
                              color={
                                file.status === "completed"
                                  ? "text.secondary"
                                  : "error"
                              }
                              size={14}
                            >
                              {file.fileSize < 1024 * 1024
                                ? `${(file.fileSize / 1024).toFixed(2)} KB`
                                : `${(file.fileSize / (1024 * 1024)).toFixed(
                                    2
                                  )} MB`}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Divider />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  p={2.5}
                >
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box sx={{ flex: 1, ml: 2 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
                <Divider />
                <Box display="flex" flexDirection="column" p={"10px 20px"}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        height: 5,
                        backgroundColor: "#e0e0e0",
                        borderRadius: 5,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          width: `${
                            (uploadProgress / uploadingFiles.length) * 100
                          }%`,
                          backgroundColor: "#3f95ea",
                          height: "100%",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      minWidth={30}
                    >
                      {Math.round(
                        (uploadProgress / uploadingFiles.length) * 100
                      )}
                      %
                    </Typography>
                  </Box>
                  <Typography fontSize={14}>
                    {uploadProgress}/{uploadingFiles.length} Candidates
                    Processed
                  </Typography>
                </Box>
              </>
            ) : (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <CheckCircleOutlineOutlinedIcon
                    sx={{ color: "#4CAF50", fontSize: 50 }}
                  />
                  <Box>
                    <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
                      Candidates Processed Successfully!
                    </Typography>
                    <Typography fontSize={14} color="text.secondary">
                      {uploadingFiles.length}/{uploadingFiles.length}
                    </Typography>
                  </Box>
                </Box>
                <IconButton>
                  <OpenInNewOutlinedIcon
                    sx={{
                      border: "1px solid #D9EAFB",
                      borderRadius: "8px",
                      padding: "6px",
                      fontSize: "32px",
                      color: "#1A1A1A",
                    }}
                    onClick={handleOpenDetails}
                  />
                </IconButton>
              </Box>
            )}
          </Box>
        </Draggable>
      )} */}
    </Box>
  );
}
